import Pagination from './Pagination';

export default Pagination;
export * from './Pagination';
